<template>
  <div>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>類型</th>
        <th>值</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center">
          <a class="btn btn-primary" href="#" @click="submit(item)"><i class="fa fa-save"></i></a>
        </td>
        <td >
          {{item.title}}
        </td>
        <td >
          <div v-if="item.uitype==='text'">
            <input type="text" class="form-control" placeholder="" v-model="item.value">
          </div>
          <div v-if="item.uitype==='textarea'">
            <textarea class="form-control" rows="5" v-model="item.value"></textarea>
          </div>
          <div v-else-if="item.uitype==='image'">
            <img :src="convertToRealUrl(item.value)" style="width:300px;height: 200px">
            <FileUploadButton :emmit-back-param="item" v-on:uploadSuccess="uploadSuccess" file-type="file" ></FileUploadButton>
          </div>
          <div v-else-if="item.uitype==='html'">
            <MyCkEditor ref="myCkEditor" v-model="item.value"  height="200" width="100%" :file-upload-list-lite_is-show="false"></MyCkEditor>
          </div>
          <div v-if="item.uitype==='number'">
            <input type="number" class="form-control" placeholder="" v-model="item.value">
          </div>
          <div v-else>

          </div>

        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/
import apiAdmin from "@/taylorCommon/apiAdmin";
import {
  Setting_QueryType_SiteUrl,
  Setting_QueryType_SiteTitle,
  Setting_QueryType_SEO_site_name,
  Setting_QueryType_SEO_title,
  Setting_QueryType_SEO_description,
  Setting_QueryType_SEO_url,
  Setting_QueryType_SEO_image,
  Setting_QueryType_SiteTime,
  Setting_QueryType_SiteAddress,
  Setting_QueryType_SiteGoogleMapUrl,
  Setting_QueryType_Meta_Keyword,
  Setting_QueryType_Meta_Description,
  Setting_QueryType_Code, Setting_QueryType_SMS_VerifyCode, Setting_QueryType_SMS_OrderSuccess,Setting_QueryType_Disclaimer,Setting_QueryType_Privacy,Setting_QueryType_Payment,Setting_QueryType_Ship,Setting_QueryType_LoginSuccess,Setting_QueryType_ForgotSuccess,Setting_QueryType_OrderSuccess,Setting_QueryType_ShipFee,Setting_QueryType_ShipFee2,Setting_QueryType_ShipFeeTotalAmount,Setting_QueryType_SMS_Order2Success,Setting_QueryType_EventDefine2
} from "./js/fireGodsDeclare";
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";
import FileUploadButton from "@/taylorCommon/component/FileUploadButton.vue";
import Vue from "vue";

export default {
  components: {FileUploadButton, MyCkEditor},
  data: function () {
    return {
      datas:[
        {
          settingQueryType:Setting_QueryType_SiteUrl,
          title:"網站網址 (例 https://google.com)",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SiteTitle,
          title:"網站標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SEO_site_name,
          title:"SEO og:site_name",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SEO_title,
          title:"SEO og:title",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SEO_description,
          title:"SEO og:description",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SEO_url,
          title:"SEO og:url",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SEO_image,
          title:"SEO og:image",
          uitype:"image",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SiteTime,
          title:"問事時間",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SiteAddress,
          title:"道場地址",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SiteGoogleMapUrl,
          title:"道場 GoogleMap網址",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_Meta_Keyword,
          title:"Meta keywords",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_Meta_Description,
          title:"Meta description",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_Code,
          title:"追蹤碼",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SMS_VerifyCode,
          title:"簡訊 驗證碼",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SMS_OrderSuccess,
          title:"簡訊 訂單付款成功",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_Disclaimer,
          title:"免責聲明",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_Privacy,
          title:"隱私權政策",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_Payment,
          title:"付款方式",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_Ship,
          title:"運送方式",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_LoginSuccess,
          title:"登入成功",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_ForgotSuccess,
          title:"重設密碼",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_OrderSuccess,
          title:"訂購成功",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_ShipFee,
          title:"運費金額(本島)",
          uitype:"number",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_ShipFee2,
          title:"運費金額(外島)",
          uitype:"number",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_ShipFeeTotalAmount,
          title:"免運金額",
          uitype:"number",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_SMS_Order2Success,
          title:"簡訊 文創商品訂單付款成功",
          uitype:"textarea",
          value:"",
        },
        {
          settingQueryType:Setting_QueryType_EventDefine2,
          title:"專題活動說明文字",
          uitype:"html",
          value:"",
        },
      ],
      datasTemplate:[
        {
          settingQueryType:"",
          title:"",
          value:"",
        },
      ],
    };
  },
  methods: {
    async loadData() {
      let settingValue="";

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SiteUrl);
      this.datas[0].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SiteTitle);
      this.datas[1].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SEO_site_name);
      this.datas[2].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SEO_title);
      this.datas[3].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SEO_description);
      this.datas[4].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SEO_url);
      this.datas[5].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SEO_image);
      this.datas[6].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SiteTime);
      this.datas[7].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SiteAddress);
      this.datas[8].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SiteGoogleMapUrl);
      this.datas[9].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_Meta_Keyword);
      this.datas[10].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_Meta_Description);
      this.datas[11].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_Code);
      this.datas[12].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SMS_VerifyCode);
      this.datas[13].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SMS_OrderSuccess);
      this.datas[14].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_Disclaimer);
      this.datas[15].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_Privacy);
      this.datas[16].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_Payment);
      this.datas[17].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_Ship);
      this.datas[18].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_LoginSuccess);
      this.datas[19].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_ForgotSuccess);
      this.datas[20].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_OrderSuccess);
      this.datas[21].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_ShipFee);
      this.datas[22].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_ShipFee2);
      this.datas[23].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_ShipFeeTotalAmount);
      this.datas[24].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_SMS_Order2Success);
      this.datas[25].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(Setting_QueryType_EventDefine2);
      this.datas[26].value=settingValue.data.data;

    },
    submit(item){
      apiAdmin.api_admSetting_Save(item.settingQueryType,item.value).then((data)=>{
        alert('儲存成功');
      })
    },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.value=result.data.FileUrls[0]
      }else{
        alert("檔案上傳失敗")
      }
    },



  },
  mounted() {
    this.loadData();
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
